import React from 'react';
import { ReelImage } from './ReelImage';
import { ReelVideo } from './ReelVideo';
import { useGet } from '../../hooks/useApi';
import { ReelSession } from './model/ReelSession';
import { isPhoto, isVideo } from '../../models/FileModel';
import { FilesAPI } from '../../APIs/filesApi';

export type ReelFileDisplayProps = {
    fileId: string;
    session: ReelSession;
    videoTimeSeconds?: number;
};
export const ReelFileDisplay = ({
    fileId,
    session,
    videoTimeSeconds,
}: ReelFileDisplayProps) => {
    const file = useGet(FilesAPI.item(fileId));
    if (file.isLoading || !file.data) {
        return <div className="reel--box-container reel--mode--loading"></div>;
    }
    if (!file.data.data.file?.url) {
        return <>???</>;
    }
    if (isPhoto(file.data.data)) {
        return (
            <ReelImage
                fileId={fileId}
                src={file.data.data.file.url}
                session={session}
            />
        );
    }
    if (isVideo(file.data.data))
        return (
            <ReelVideo
                src={file.data.data.file.url}
                videoTimeSeconds={videoTimeSeconds ?? 0}
            />
        );
    return <></>;
};
